import * as React from "react";
import { useCallback } from "react";
import Box from "@mui/material/Box";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import workflowArrow from "../../../../styles/svg/workflowArrow.svg";
import adminWorkflowEdit from "../../../../styles/svg/adminWorkflowEdit.svg";
import adminWorkflowDelete from "../../../../styles/svg/adminWorkflowDelete.svg";
import CreateWorkflow from "./createWorkflowPopup/CreateWorkflow";
import DeleteWorkflow from "./DeleteWorkflow";
import { useWorkflowTableState } from "../hooks/useWorkflowTableState";
import {
  formatWorkflowStepLabel,
} from "../utils/workflowAdminUtils";

function WorkFlowTable() {
  const {
    rows,
    showEditWorkflow,
    editWorkflowData,
    workflowId,
    showDelete,
    sortModel,
    setSortModel,
    handleEditWorkflowClose,
    handleEditWorkflow,
    handleDeleteWorkflow,
    handleDeleteClose,
  } = useWorkflowTableState();

  const renderSteps = useCallback((params) => {
    const { value } = params;
    return (
      <div
        className="d-flex"
        style={{
          overflowX: "auto",
        }}
      >
        {value.map((step, index) => (
          <React.Fragment
            key={`workflow-step-${step.workflowstep_id || `${step.status}-${index}`}`}
          >
            <div className="workflow-steps">
              {formatWorkflowStepLabel(step.status)}
            </div>
            {index < value.length - 1 && (
              <img src={workflowArrow} alt="" className="stepArrow" />
            )}
          </React.Fragment>
        ))}
      </div>
    );
  }, []);

  const renderAction = useCallback(
    (params) => {
      const { id, row } = params;

      return (
        <div className="d-flex ">
          <img
            src={adminWorkflowEdit}
            alt="edit workflow icon"
            className="adminWorkflowEdit"
            onClick={() => handleEditWorkflow(row, id)}
          />
          <img
            src={adminWorkflowDelete}
            alt="delete workflow icon"
            className="adminWorkflowDelete"
            onClick={() => handleDeleteWorkflow(id)}
          />
        </div>
      );
    },
    [handleEditWorkflow, handleDeleteWorkflow]
  );

  const columns = [
    {
      field: "col1",
      headerName: "Workflow Name",
      minWidth: 150,
      flex: 0.45,
      cellClassName: "name-wrap",
    },
    {
      field: "col2",
      headerName: "Steps",
      minWidth: 250,
      flex: 1.3,
      renderCell: renderSteps,
      disableSort: true,
      sortable: false,
    },
    {
      field: "col3",
      headerName: "Actions",
      minWidth: 100,
      flex: 0.3,
      renderCell: renderAction,
      disableSort: true,
    },
  ];

  return (
    <>
      {showDelete && (
        <DeleteWorkflow
          workflowId={workflowId}
          showDelete={showDelete}
          handleDeleteClose={handleDeleteClose}
        />
      )}

      {showEditWorkflow && (
        <CreateWorkflow
          workflowId={workflowId}
          open={showEditWorkflow}
          close={handleEditWorkflowClose}
          workflowData={editWorkflowData}
          edit={true}
        />
      )}
      <Box sx={{ width: "100%" }} className="table-datagrid">
        <DataGrid
          autoHeight
          pagination={false}
          rows={rows}
          columns={columns}
          hideFooter={true}
          disableRowSelectionOnClick
          disableColumnFilter
          disableColumnMenu
          sortModel={sortModel}
          onSortModelChange={(model) => setSortModel(model)}
          getRowId={(row) => row.id}
          classes={{
            cell: "data-grid-cell",
            columnHeader: "table-header-class",
          }}
          sx={{
            [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]:
              {
                outline: "none",
              },
            [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
              {
                outline: "none",
              },
          }}
        />
      </Box>
    </>
  );
}

export default React.memo(WorkFlowTable);
